$(document).ready(function(){

  // MOBILE MENU TOGGLE

  var mobileMenuToggler = $('[js-mobile-menu-toggler]');
  var mobileMenu = $('body');
  var menuOpened = false;

  mobileMenuToggler.on('click', function() {
    if (menuOpened === false) {
      mobileMenu.addClass('mobile-menu--opened');
      menuOpened = true;
    }
    else {
      mobileMenu.removeClass('mobile-menu--opened');
      menuOpened = false;
    }
  });


  // ONLINE SERVICES TOGGLE

  var onlineServicesToggler = $('.online-services');
  var onlineServicesClose = $('[js-online-services-overlay]');
  var onlineServices = $('body');
  var onlineServicesOpened = false;

  onlineServicesToggler.on('click', function() {
    if (onlineServicesOpened === false) {
      onlineServices.addClass('gie-services--opened');
      onlineServicesOpened = true;
    }
    else {
      onlineServices.removeClass('gie-services--opened');
      onlineServicesOpened = false;
    }
  });

  onlineServicesClose.on('click', function() {
    onlineServices.removeClass('gie-services--opened');
    onlineServicesOpened = false;
  });

});
